define(
	'C3.ShoppingExtensions.LoginRegister.ForgotPassword.Confirmation.View',
	['SCView', 'c3_shoppingextensions_loginregister_forgotpassword_confirmation.tpl'],
	function(SCViewComponent, c3_shoppingextensions_loginregister_forgotpassword_confirmation_tpl) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function ForgotPasswordConfirmationView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = c3_shoppingextensions_loginregister_forgotpassword_confirmation_tpl;

			this.modalClass = "global-views-modal-small"

			this.loginPopup = function loginPopup(e)
			{
				e.stopPropagation();
				e.preventDefault();
				jQuery('.dontshow-magic-link .dontshow-link').trigger('click',true);
			}

		}

		// Inherit parent instance methods.
		ForgotPasswordConfirmationView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		ForgotPasswordConfirmationView.prototype.constructor = ForgotPasswordConfirmationView;

		ForgotPasswordConfirmationView.prototype.getEvents = function() {
            return {
                'click [data-action="login-popup"]':'loginPopup'
            };
        }

		ForgotPasswordConfirmationView.prototype.getContext = function() {

			return {
				
			}
		}

		// Return the AMD constructor.
		return ForgotPasswordConfirmationView;
	}
);
